import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function resolveImage(url) {
  if (!url) return null;
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}

export function toYouTubeEmbed(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export function apiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
}

export const CATEGORIES = [
  { value: "story", label: "India's Story", hindi: "भारत की कहानी" },
  { value: "growth", label: "Growth", hindi: "विकास" },
  { value: "geopolitics", label: "Geopolitics", hindi: "भू-राजनीति" },
];

const LEGACY_LABELS = { culture: "India's Story", tradition: "India's Story", diversity: "India's Story", general: "India's Story" };

export const categoryLabel = (v) => CATEGORIES.find((c) => c.value === v)?.label || LEGACY_LABELS[v] || v;

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
